module.exports = __webpack_public_path__ + "img/monitor.b1ba8c99.png";